import makeApiRequest from 'src/lib/makeApiRequest';
import { API_URL } from 'src/constants/Endpoints';
import {
  AmbassadorPayload,
  FundraisingInfo,
  FundraisingMatchingInfo,
} from 'src/models/FundraisingModel';

// export const getFundraisingsData =
//   (organisation: string) => makeApiRequest({
//     method: 'GET',
//     url: API_URL.fundraising,
//     organisation,
//   });

export const getFundraisingData =
  (organisation: string, id: string | number) => makeApiRequest({
    method: 'GET',
    url: `${API_URL.fundraising}/${id}`,
    organisation,
  });

export const deleteFundraisingData =
  (organisation: string, id: string) => makeApiRequest({
    method: 'DELETE',
    url: `${API_URL.fundraising}/${id}`,
    organisation,
  });

export const activateFundraisingData =
  (organisation: string, id: string, state: boolean) => makeApiRequest({
    method: 'DELETE',
    url: `${API_URL.fundraising}/${id}/${state}`,
    organisation,
  });

export const postFundraisingInfoData =
  (organisation: string, data: FundraisingInfo | FundraisingMatchingInfo) => makeApiRequest({
    method: 'POST',
    url: API_URL.fundraisingInfo,
    organisation,
    data,
  });

export const putFundraisingInfoData =
  (organisation: string, id: number, data: any) => makeApiRequest({
    method: 'PUT',
    url: `${API_URL.fundraisingInfo}/${id}`,
    organisation,
    data,
  });

export const putFundraisingProductsData =
  (organisation: string, id:number, data: any) => makeApiRequest({
    method: 'PUT',
    url: `${API_URL.fundraisingProducts}/${id}`,
    organisation,
    data,
  });

export const putFundraisingAmbassadorsData =
  (organisation: string, id: number, data: any) => makeApiRequest({
    method: 'PUT',
    url: `${API_URL.fundraisingAmbassador}/${id}`,
    organisation,
    data,
  });

export const putFundraisingNotificationsData =
  (organisation: string, id:number, data: any) => makeApiRequest({
    method: 'PUT',
    url: `${API_URL.fundraisingNotifications}/${id}`,
    organisation,
    data,
  });

export const putFundraisingAssetsData =
  (organisation: string, id:number, data: any) => makeApiRequest({
    method: 'PUT',
    url: `${API_URL.fundraisingAssets}/${id}`,
    organisation,
    data,
  });

export const getAmbassadorListData =
  (organisation: string, fundraisindId: string | number) => makeApiRequest({
    method: 'GET',
    url: `${API_URL.ambassadors}/${fundraisindId}`,
    organisation,
  });

export const postAmbassadorData =
  (organisation: string, data: AmbassadorPayload) => makeApiRequest({
    method: 'POST',
    url: API_URL.ambassador,
    organisation,
    data,
  });

export const putAmbassadorData =
  (organisation: string, data: AmbassadorPayload) => makeApiRequest({
    method: 'PUT',
    url: `${API_URL.ambassador}/${data.id}`,
    organisation,
    data,
  });

export const deleteAmbassadorData =
  (id: number, organisation: string) => makeApiRequest({
    method: 'DELETE',
    url: `${API_URL.ambassador}/${id}`,
    organisation,
  });

export const getAmbassadorByIdData =
  (id: number | string, organisation: string) => makeApiRequest({
    method: 'GET',
    url: `${API_URL.ambassador}/${id}`,
    organisation,
  });
